import '../../components/resource_limit_counter';
import './index.scss';
import 'components/empty_list_message';
import 'components/freemium/block_message';
import 'components/video_player';
import 'styles/components/_responsive-embed.scss';
import FeedbackForm from 'components/commentary_feedback_form';
import QuestionLikes from '../question_likes';
import RequestCommentsModal from 'components/modals/request_comments_modal';
import Study from 'utils/study/study';
import { EventManager } from 'utils/event_manager';
import { handleApiError } from 'utils/api_error_handler';
import { runTextOverlayScript } from 'components/freemium/text_overlay';

class QuestionTeacherTab {
  constructor($context) {
    this.$context = $context;
    this.questionId = $('.q-question-teacher', this.$context).data(
      'question-id'
    );
    this.$changeCommentTypeButton = $('.js-change-comment-type', this.$context);

    this.bind();

    this.feedbackForm = new FeedbackForm(this.$context);

    new QuestionLikes(this.$context);
  }

  requestComments(currentTarget) {
    const $title = $(currentTarget).parent().find('h3');
    const $text = $(currentTarget).parent().find('p');
    const $button = $(currentTarget);

    RequestCommentsModal.open(
      this.questionId,
      `Q${this.questionId}`,
      function () {
        $button.html($button.data().label);
        $text.html($text.data().label);
        $title.html($title.data().label);
      }
    );
  }

  updateCounts(selector, sum) {
    const isPlainValue = typeof sum === 'number';

    const sumNumber = isPlainValue ? sum : sum.value;
    const $counter = $(selector, this.$context.parents('.q-question-belt'));
    const newCount = parseInt($counter.html()) + sumNumber;

    $counter.html(newCount);
  }

  updateTotalCounter(event, sum) {
    this.updateCounts('.js-comments-count', sum);
  }

  updateTeachersCounter(event, sum) {
    this.updateCounts('.js-comments-teachers-count', sum);
  }

  changeCommentType(e) {
    const data = e.currentTarget.dataset;
    const id = parseInt(data.id);

    Thor.Commentary.unrecommend(
      { id },
      {
        data: {
          recommend: false
        }
      }
    )
      .then(() => {
        EventManager.publish(
          `questionBelt.${this.questionId}.comments.updateTotal`,
          {
            value: 1,
            context: this.$context.parents('.q-question-belt')
          }
        );

        EventManager.publish(
          `questionBelt.${this.questionId}.commentsTeachers.updateTotal`,
          {
            value: -1,
            context: this.$context.parents('.q-question-belt')
          }
        );

        window.QuestionBelt.loadTab(
          this.$context.parents('.q-question-belt'),
          'question_teacher',
          true
        );
      })
      .catch(({ response }) => {
        handleApiError('Ops! Parece que aconteceu algum erro!', response);
      });
  }

  _bindChangeCommentType() {
    this.$changeCommentTypeButton
      .off('click.question_comment_change_type')
      .on('click.question_comment_change_type', e => this.changeCommentType(e));
  }

  _bindListeners() {
    EventManager.unsubscribe(
      `questionBelt.${this.questionId}.comments.updateTotal`
    );
    EventManager.unsubscribe(
      `questionBelt.${this.questionId}.commentsTeachers.updateTotal`
    );

    EventManager.subscribe(
      `questionBelt.${this.questionId}.comments.updateTotal`,
      this.updateTotalCounter.bind(this)
    );
    EventManager.subscribe(
      `questionBelt.${this.questionId}.commentsTeachers.updateTotal`,
      this.updateTeachersCounter.bind(this)
    );
  }

  bind() {
    const $emptyListMessage = $('.q-empty-list-message a', this.$context);

    if ($emptyListMessage.length) {
      $emptyListMessage.off('click').on('click', e => {
        e.preventDefault();

        this.requestComments(e.currentTarget);
      });
    }

    this._bindChangeCommentType();
    this._bindListeners();
  }
}

(function ($) {
  'use strict';

  $(document)
    .off('componentLoaded:questions/question_teacher')
    .on('componentLoaded:questions/question_teacher', (e, data) => {
      new QuestionTeacherTab(data.context);

      const $elem = $('.q-question-teacher', data.context);

      const hasCommentary = $elem.data('has-commentary');
      const hasEmptyCommentary = !hasCommentary && $elem.length === 1;
      const isCommentaryText = $elem.data('is-commentary-text');
      const commentaryType = $elem.data('commentary-type');

      let contentType = '';

      if (hasCommentary) {
        contentType = isCommentaryText ? 'text' : 'video';
      }

      if (hasEmptyCommentary) {
        contentType = 'empty';
      }

      UserTracker.emit('event', {
        eventName: 'professor feedback clicked',
        data: {
          source_project: 'odin',
          request_path: window.location.pathname,
          'commentary type': commentaryType,
          'content type': contentType
        }
      });

      runTextOverlayScript('teachers');

      if (
        hasCommentary &&
        isCommentaryText &&
        currentUser.subscriptionStatus !== 'standard'
      ) {
        Study.track('teachers');
      }
    });
})(jQuery);
